package com.brdgwtr.designsystem.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import com.brdgwtr.designsystem.Icons

public val Icons.NotificationFilled: ImageVector
    get() {
        if (_notificationFilled != null) {
            return _notificationFilled!!
        }
        _notificationFilled = Builder(name = "NotificationFilled", defaultWidth = 48.0.dp,
                defaultHeight = 48.0.dp, viewportWidth = 48.0f, viewportHeight = 48.0f).apply {
            path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(8.0f, 38.0f)
                verticalLineToRelative(-3.0f)
                horizontalLineToRelative(4.0f)
                lineTo(12.0f, 19.8f)
                curveToRelative(0.0f, -2.8f, 0.825f, -5.308f, 2.475f, -7.525f)
                curveTo(16.125f, 10.058f, 18.3f, 8.667f, 21.0f, 8.1f)
                lineTo(21.0f, 7.0f)
                curveToRelative(0.0f, -0.833f, 0.292f, -1.542f, 0.875f, -2.125f)
                arcTo(2.893f, 2.893f, 0.0f, false, true, 24.0f, 4.0f)
                curveToRelative(0.833f, 0.0f, 1.542f, 0.292f, 2.125f, 0.875f)
                reflectiveCurveTo(27.0f, 6.167f, 27.0f, 7.0f)
                verticalLineToRelative(1.1f)
                curveToRelative(2.7f, 0.567f, 4.875f, 1.958f, 6.525f, 4.175f)
                curveTo(35.175f, 14.492f, 36.0f, 17.0f, 36.0f, 19.8f)
                lineTo(36.0f, 35.0f)
                horizontalLineToRelative(4.0f)
                verticalLineToRelative(3.0f)
                lineTo(8.0f, 38.0f)
                close()
                moveTo(24.0f, 44.0f)
                curveToRelative(-1.1f, 0.0f, -2.042f, -0.392f, -2.825f, -1.175f)
                curveTo(20.392f, 42.042f, 20.0f, 41.1f, 20.0f, 40.0f)
                horizontalLineToRelative(8.0f)
                curveToRelative(0.0f, 1.1f, -0.392f, 2.042f, -1.175f, 2.825f)
                curveTo(26.042f, 43.608f, 25.1f, 44.0f, 24.0f, 44.0f)
                close()
            }
        }
        .build()
        return _notificationFilled!!
    }

private var _notificationFilled: ImageVector? = null
